import { forwardRef, Inject, Pipe, PipeTransform } from "@angular/core";
import { BadgeSettings, StyleConfigurationService } from "../../service/style-configuration.service";
import { UnderscoreRemoverPipe } from "./underscore-remover.pipe";

@Pipe({ name: 'syBadge' })
export class ServitlyBadgePipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => StyleConfigurationService)) private styleConfigurationService: StyleConfigurationService,
        @Inject(forwardRef(() => UnderscoreRemoverPipe)) private underscoreRemoverPipe: UnderscoreRemoverPipe
    ) { }

    transform(label: string, settings: BadgeSettings = {}): string {
        if (!label) {
            return '';
        }
        const colorHex = this.computeColor(label, settings);
        const leadingIcon = (settings.showLeadingIcon === false) ? '' : `<span style="color: ${colorHex}"></span>`; // must be explicit
        const normalizedLabel = this.underscoreRemoverPipe.transform(label);
        return `
            <div class="sy-badge" style="color: color-mix(in srgb, ${colorHex}, black 30%); background-color: color-mix(in srgb, ${colorHex} 15%, transparent)">
                ${leadingIcon}
                <div class="sy-badge-label">${normalizedLabel}</div>
            </div>
        `
    }


    private computeColor(label: string, settings: BadgeSettings): string {
        const uiToolkit = this.styleConfigurationService.getUIToolkit();
        let colorHex = null;
        if (!uiToolkit) {
            return settings.color || "#000000";
        }
        if (settings.colorTokenPrefix) {
            colorHex = uiToolkit.getColor(this.getTokenValue(label, settings.colorTokenPrefix));
        }
        if (!colorHex && settings.colorToken) {
            colorHex = uiToolkit.getColor(settings.colorToken)
        }
        if (!colorHex && settings.color) {
            return settings.color;
        }
        if (!colorHex) {
            colorHex = uiToolkit.getColor(this.getTokenValue(label)); // retrieve with suffix only
        }
        if (!colorHex) {
            colorHex = uiToolkit.assignColor(this.getTokenValue(label));
        }
        return colorHex;
    }

    private getTokenValue(label: string, colorTokenPrefix?: string): string {
        const tokenSuffix = (label as any).trim().replaceAll('_', '-').replaceAll(' ', '-').toLowerCase();
        if (colorTokenPrefix) {
            return `${colorTokenPrefix}-${tokenSuffix}`
        }
        return tokenSuffix;
    }
}

